import {
  FormControl,
  InputLabel,
  alpha,
  styled
} from '@mui/material';
import InputBase from '@mui/material/InputBase';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#E0E3E7' : '#2D3843',
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:focus': {
    },
  },
}));

export default function BootstrapFormField({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  multiline = false,
  rows = 1,
  fullWidth = true,
  type = 'text',
  placeholder,
  error = false,
  helperText,
  ...otherProps
}) {
  const inputId = id || `${label?.toLowerCase().replace(/\s+/g, '-')}-input`;

  return (
    <FormControl variant="standard" fullWidth={fullWidth} error={error}>
      {label && (
        <InputLabel
          shrink
          htmlFor={inputId}
          sx={{
            fontSize: '1.2rem',
            fontWeight: 500,
            color: error ? 'error.main' : 'inherit'
          }}
        >
          {label}
        </InputLabel>
      )}
      <BootstrapInput
        id={inputId}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        type={type}
        placeholder={placeholder}
        error={error}
        {...otherProps}
      />
      {helperText && (
        <div style={{
          fontSize: '0.75rem',
          color: error ? 'red' : '#666',
          marginTop: '4px',
          marginLeft: '14px'
        }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
}